export const GET_ORGAN_SUCCESS = "GET_ORGAN_SUCCESS";
